import { PUBLIC_PRODUCT_CATALOG } from '../../utils/productCatalog';
import { hasProductAccess } from '../../utils/billing';

const DARK_TEXT_PRODUCTS = new Set(['linkpage', 'crm', 'reservo', 'cardapio']);

export const USER_PRODUCT_DEFINITIONS = PUBLIC_PRODUCT_CATALOG.map((product) => ({
  key: product.productKey,
  label: product.productKey === 'atendabot' ? 'Atendabot' : product.nome,
  color: product.backgroundColor,
  textColor: DARK_TEXT_PRODUCTS.has(product.productKey) ? '#333' : '#fff',
}));

export const isEnabledProduct = (value) => (
  value === true || value === 1 || String(value).trim().toLowerCase() === 'true'
);

export const getOwnerAvailableProducts = (session = {}) => (
  USER_PRODUCT_DEFINITIONS.filter((product) => (
    hasProductAccess(session, product.key, { allowTrialRestricted: true })
  ))
);

export const getUserProductsByKeys = (productKeys = []) => {
  const allowedKeys = new Set(Array.isArray(productKeys) ? productKeys : []);
  return USER_PRODUCT_DEFINITIONS.filter((product) => allowedKeys.has(product.key));
};
